import { render } from "./z-page.vue?vue&type=template&id=14bd3ddd"
import script from "./z-page.vue?vue&type=script&lang=js"
export * from "./z-page.vue?vue&type=script&lang=js"

import "./z-page.vue?vue&type=style&index=0&id=14bd3ddd&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__